export default __webpack_public_path__ + "static/summer_containers97-b18cf53e2f8ac388442ce3efc9fc1bdd.webp";